import { Entity } from "../base/entity";

export class DocumentItemDetail extends Entity {
  id: number;
  documentId: string;
  itemId: string;
  eitemId: string;
  quantity: number;
  returnedQuantity: number;
  sort: number;
}
